import createIcon from '../../createIcon';

/**
 * @component @name FilterDrama
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkuMzUgMTAuMDRDMTguNjcgNi41OSAxNS42NCA0IDEyIDRDOS4xMSA0IDYuNjEgNS42NCA1LjM2IDguMDRDMi4zNSA4LjM2IDAgMTAuOSAwIDE0QzAgMTcuMzEgMi42OSAyMCA2IDIwSDE5QzIxLjc2IDIwIDI0IDE3Ljc2IDI0IDE1QzI0IDEyLjM2IDIxLjk1IDEwLjIyIDE5LjM1IDEwLjA0Wk0xOSAxOEg2QzMuNzkgMTggMiAxNi4yMSAyIDE0QzIgMTEuNzkgMy43OSAxMCA2IDEwQzguMjEgMTAgMTAgMTEuNzkgMTAgMTRIMTJDMTIgMTEuMjQgMTAuMTQgOC45MiA3LjYgOC4yMkM4LjYxIDYuODggMTAuMiA2IDEyIDZDMTUuMDMgNiAxNy41IDguNDcgMTcuNSAxMS41VjEySDE5QzIwLjY1IDEyIDIyIDEzLjM1IDIyIDE1QzIyIDE2LjY1IDIwLjY1IDE4IDE5IDE4WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FilterDrama = createIcon('FilterDrama', [
  [
    'path',
    {
      d: 'M19.35 10.04C18.67 6.59 15.64 4 12 4C9.11 4 6.61 5.64 5.36 8.04C2.35 8.36 0 10.9 0 14C0 17.31 2.69 20 6 20H19C21.76 20 24 17.76 24 15C24 12.36 21.95 10.22 19.35 10.04ZM19 18H6C3.79 18 2 16.21 2 14C2 11.79 3.79 10 6 10C8.21 10 10 11.79 10 14H12C12 11.24 10.14 8.92 7.6 8.22C8.61 6.88 10.2 6 12 6C15.03 6 17.5 8.47 17.5 11.5V12H19C20.65 12 22 13.35 22 15C22 16.65 20.65 18 19 18Z',
      key: '1av6im',
    },
  ],
]);

export default FilterDrama;
